export default {"src":"/_next/static/media/instagram.04e95538.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};